import { mapState } from 'vuex';
import multiSearchMixin from '@/mixins/multiSearchDigitalTwins';
export default {
  name: 'CoreCsvExportSearchDigitalTwins',
  mixins: [multiSearchMixin],
  props: {
    search: {
      type: Array,
      required: false,
      default: () => []
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    copyMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color'])
  },
  mounted() {
    this.searchItems = this.search;
  },
  methods: {}
};